import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import _flattenDeep from 'lodash/flattenDeep';
import {canvasReducer as canvas,canvasMiddleware} from './reducers/canvas';
import {userAccessReducer as userAccess, userAccessMiddleware} from './reducers/userAccess';
import {coursesReducer as courses, coursesMiddleware} from './reducers/courses'
import {sectionsReducer as sections, sectionsMiddleware} from './reducers/sections'

// redux reducers combined into a single option (makes easily accessible when debugging)
const reducer = combineReducers({
    canvas,
    userAccess,
    courses,
    sections
})

// using our custom middleware enables us to isolate the actions from the code that makes the http request
// using thunk would forces us to make the actions more complicated by sending the HTTP request and handling the response
const middleware = applyMiddleware.apply(null, _flattenDeep([
    canvasMiddleware,
    userAccessMiddleware,
    coursesMiddleware,
    sectionsMiddleware
]))

// enable redux debugging
const composeEnhancers = (typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ) || compose;

const store = createStore(reducer, composeEnhancers(middleware));
export default store;